module.exports = __webpack_public_path__ + "img/interact-banner.41f55364.png";